import Swiper from 'swiper';

export function testimonialCarousel(element: HTMLElement): void {
  const swiperEl = element.querySelector('.swiper') as HTMLElement
  const rightCover = element.querySelector('.right-cover') as HTMLElement
  const containerEl = element.querySelector('.container') as HTMLElement

  const swiper = new Swiper(swiperEl, {
    slidesPerView: 1.15,
    spaceBetween: 24,
    slidesOffsetAfter: 64,
    grabCursor: true,
    breakpoints: {
      768: {
        slidesPerView: 1.3,
      },
      1300: {
        slidesPerView: 2.5,
      }
    }
  })

  // Because the container is dynamically sized, we need to adjust the width of a "right cover"
  // as the Swiper carousel needs to overflow to the left but not to the right
  // It is not possible to do this in CSS as the container has padding which is relative to 
  // itself so cannot be included int he calculation for the width of the cover (in CSS alone)
  const adjustCoverWidth = () => {
    const containerWidth = containerEl.offsetWidth;
    const containerPadding = parseInt(window.getComputedStyle(containerEl).paddingLeft);
    const viewportWidth = Math.max(window.innerWidth);
    const coverWidth = (viewportWidth - containerWidth) / 2 + containerPadding;
    rightCover.style.width = `${coverWidth}px`;
  };

  adjustCoverWidth();
  window.addEventListener('resize', adjustCoverWidth);
}
